import AccountQuestion from './container/AccountQuestion';

export default  AccountQuestion;



// WEBPACK FOOTER //
// ./src/views/AccountQuestion/index.js